import { makeStyles } from "@mui/styles";
import { Box, Button, Typography } from "@mui/material";
import BorderLinearProgress from "../../global/linear-progress";
import CustomModal from "../../global/custom-modal";
import { useState } from "react";
import GetTrace from "./get-trace";
import useSaleFactorStore from "../../../store/out-warehouse/useSaleFactorStore";
import { useMutation } from "react-query";
import AxiosT from "../../../setup/setup-axios-bearer";

const useStyles = makeStyles({
  factoItem: {
    marginBottom: "24px",
    background: "#fff",
    border: "1px solid #B9BACC",
    borderRadius: "11px",
    "& Button": {
      background: "#264BF0",
      color: "#fff",
      width: "100%",
      borderRadius: "0 0 11px 11px !important",
    },
  },
  top: {
    borderRadius: "11px 11px 0 0",
    background: "#2530B8",
    color: "#fff",
    padding: "12px",
    display: "flex",
    justifyContent: "space-between",
  },
  count: {
    width: "24px",
    height: "24px",
    minWidth: "24px",
    borderRadius: "50%",
    color: "#fff",
    background: "#264BF0",
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    marginRight: "4px",
  },
  middle: {
    padding: "12px 24px",
  },
});

const SaleFactorDetailNested = ({
  product_name,
  product_code,
  count,
  count_logs,
  item_id,
}) => {
  const classes = useStyles();
  const [action, setAction] = useState("get-trace");
  const [details, setDetails] = useState();
  const factorID = useSaleFactorStore((store) => store.factorID);
  const [openModal, setOpenModal] = useState(false);

  const { data, isLoading, mutate } = useMutation(
    ({ action, item_id }) =>
      AxiosT.post(`/out-warehouse-with-factor/${factorID}`, {
        action,
        item_id,
      }),
    {
      onSuccess: (data) => {
        setDetails(data.data.result.items);
      },
    }
  );

  const handleShowDetail = () => {
    mutate({
      action,
      item_id: item_id,
    });
    setOpenModal(true);
  };

  let progress_value;
  if (count_logs === "0") {
    progress_value = 0;
  } else {
    progress_value = (count_logs * 100) / count;
  }

  return (
    <Box className={classes.factoItem}>
      <Box className={classes.top}>
        <Box display="flex">
          <Typography variant="h3" ml={0.5} fontWeight="700">
            {product_name}
          </Typography>{" "}
          -
          <Typography variant="h3" mr={0.5}>
            {product_code}
          </Typography>
        </Box>
        <Typography variant="h3">
          تعداد
          <Box className={classes.count}>{count}</Box>
        </Typography>
      </Box>
      <Box className={classes.middle}>
        <Typography
          variant="h3"
          fontWeight="900"
          textAlign="center"
          color="#264BF0"
        >
          وضعیت اقلام خارج شده
        </Typography>
        <Box display="flex" justifyContent="space-between" px={1} mt={2}>
          <Typography variant="h3">0</Typography>
          <Typography variant="h3">{count}</Typography>
        </Box>
        <BorderLinearProgress variant="determinate" value={progress_value} />
        <Box display="flex" justifyContent="end" mt={0.5} alignItems="center">
          <Typography variant="h5" color="#264BF0">
            {count_logs}
          </Typography>
          <Typography variant="h6" color="#A5A6B0" mr={0.5}>
            کالا خارج شده است.
          </Typography>
        </Box>
      </Box>
      <Button variant="contained" onClick={handleShowDetail}>
        مشاهده جزئیات
      </Button>

      <CustomModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        titleModal="نمایش جزئیات"
      >
        <GetTrace
          details={details}
          isLoading={isLoading}
          productName={product_name}
          productCode={product_code}
          factorID={factorID}
        />
      </CustomModal>
    </Box>
  );
};
export default SaleFactorDetailNested;
